<template>
  <div class="chatItem">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt />
    </div>
    <div class="chatWrap">
      <img
          @click="handlePreview(chatItem.chatContext)"
           :style="{
          width: imageSize.width + 'px',
          height: imageSize.height + 'px'
        }"  :src="chatItem.chatContext" @load="handleImageLoad"/>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import {ImagePreview} from "vant";
export default {
  name: "ChatPic",
  props:{
    chatItem:{
      type: Object,
      default:{}
    },
    picList:{
      type:Array,
      default:[]
    }
  },
  data(){
    return{
      defaultAvatar: defaultAvatar,
      imageSize: {
        width: 0,
        height: 0
      },
      maxWidth: 200, // 最大显示宽度
      minWidth: 100  // 最小显示宽度
    }
  },
  methods:{
    // 预览大图
    handlePreview(resUrl) {
      // const index = 0;
      if (!this.picList || this.picList.length === 0) {
        console.warn('图片列表为空');
        return;
      }
      // 2. 找到当前图片在picList中的索引
      const currentIndex = this.picList.findIndex(item =>
          item.chatContext === resUrl
      );

      // 3. 如果找不到匹配项，默认显示第一张
      const startPosition = currentIndex !== -1 ? currentIndex : 0;

      // 4. 提取所有图片URL用于预览
      const previewImages = this.picList.map(item =>
          item.chatContext
      ).filter(Boolean); // 过滤掉无效URL

      ImagePreview({
        images: previewImages,
        startPosition,
        onClose: () => {
          // 预览关闭时的回调（可选）
        }
      });
    },
    handleImageLoad(event) {
      const img = event.target;
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;
      // console.log('大小------',naturalWidth);
      // 计算等比缩放后的宽度
      let targetWidth = naturalWidth;

      // 如果原始宽度超过最大值，则缩放
      if (naturalWidth > this.maxWidth) {
        targetWidth = this.maxWidth;
      }
      // 如果原始宽度小于最小值，则放大
      else if (naturalWidth < this.minWidth) {
        targetWidth = this.minWidth;
      }

      // 计算等比高度
      const targetHeight = Math.round(
          (targetWidth / naturalWidth) * naturalHeight
      );

      this.imageSize = {
        width: targetWidth,
        height: targetHeight
      };
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px; // 原30px

  .userInfo {
    margin-left: 25px; // 原50px
    img {
      width: 34px; // 原68px
      height: 34px; // 原68px
      border-radius: 50%;
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 6px; // 原12px

    img {
      max-width: 100%; // 确保图片不会超出容器
      border-radius: 4px; // 添加圆角
      box-shadow: 0 1px 3px rgba(0,0,0,0.1); // 添加轻微阴影
    }
  }
}
</style>